module.exports = __webpack_public_path__ + "static/media/notification-arrow.9f10079c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onBoardingArrows/notification-arrow.svg
// module id = 928
// module chunks = 21